import React from "react";
import PropTypes from "prop-types";
import { StyleForms } from "../../res/styles/styleForms";

class LabelValue extends React.Component {
    render() {
        let styleLabel = this.props.labelStyle ? this.props.labelStyle : StyleForms.normalLabel;
        let styleValue = this.props.valueStyle ? this.props.valueStyle : StyleForms.normalText;
        return (
            <div className="flex-nowrap" style={{ display: "inline" }}>
                <span style={styleLabel} className={this.props.classNamesLabel}>
                    {this.props.label}
                </span>
                <span style={styleValue} className={this.props.classNamesValue}>
                    {this.props.value}
                </span>
            </div>
        );
    }
}

LabelValue.propTypes = {
    labelStyle: PropTypes.object,
    valueStyle: PropTypes.object,
    classNamesLabel: PropTypes.string,
    classNamesValue: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.number])
};

export { LabelValue as default };
